import React from 'react';
const CruzRoja = (props) => (React.createElement("svg", Object.assign({ id: "prefix__Layer_1", x: 0, y: 0, viewBox: "0 0 24 19", xmlSpace: "preserve" }, props),
    React.createElement("style", null, '.prefix__st0{fill:var(--accent)}'),
    React.createElement("path", { transform: "rotate(-45.001 11.659 9.232)", className: "prefix__st0", d: "M9.16.26h5V18.2h-5z" }),
    React.createElement("path", { transform: "rotate(-45.001 11.658 9.232)", className: "prefix__st0", d: "M2.69 6.73h17.94v5H2.69z" })));
export default CruzRoja;
